export const BASE_URL =  "https://api.kisangateway.com/";